module.exports = __webpack_public_path__ + "img/portrait-010.ea58681f.jpg";